// removed by extract-text-webpack-plugin
module.exports = {"title":"ContactAgent-hashed__title__15wO4","claimNumber":"ContactAgent-hashed__claimNumber__C_GpI","phoneInline":"ContactAgent-hashed__phoneInline__1cmEz","phoneIcon":"ContactAgent-hashed__phoneIcon__2rfB8","links":"ContactAgent-hashed__links__2tABY"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/common/components/ContactAgent/ContactAgent-hashed.scss
// module id = 1164
// module chunks = 0